<script lang="ts">
    import EmblaCarousel from 'embla-carousel';
    import { onMount } from 'svelte';
    import CarouselImage from './CarouselImage.svelte';
    import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';
    import type { OptionsType } from 'embla-carousel/components/Options';
    import type { EmblaCarouselType } from 'embla-carousel';

    interface Image {
        title?: string;
        width?: number;
        height?: number;
        description?: string;
        src?: string;
        url?: string;
        srcset?: string;
        copywrite?: string;
    }

    export let lazy = true;
    export let images: Image[] = [];

    export let currentIndex = 0;
    export let isHotspotSlider = false;

    let emblaNode: HTMLDivElement;
    let embla: EmblaCarouselType;
    let canScrollNext: boolean;
    let canScrollPrev: boolean;

    $: if (embla) handleChange(); // init prev and next buttons
    $: if (emblaNode) {
        innerHeight = emblaNode.offsetHeight;
    }
    onMount(() => {
        const options: Partial<OptionsType> = { loop: true, align: 'center' };
        embla = EmblaCarousel(emblaNode, options, [WheelGesturesPlugin()]);
        embla.on('select', handleChange);
        return () => {
            if (embla) embla.destroy();
        };
    });

    function handleChange() {
        canScrollNext = embla.canScrollNext();
        canScrollPrev = embla.canScrollPrev();
        currentIndex = embla.selectedScrollSnap();
    }

    export function setIndex(index: number) {
        embla.scrollTo(index);
    }
</script>

<section class="flex max-h-[90vh] flex-col md:aspect-video md:flex-row">
    <!-- embla -->
    <div class="relative h-full w-full" style={`cursor: ${images.length > 1 ? 'grab' : 'default'}`}>
        <!-- embla-viewport -->
        <div
            bind:this={emblaNode}
            class="embla__viewport h-full max-h-full overflow-hidden bg-transparent"
        >
            <!-- embla-container -->
            <div class="embla__container flex h-full">
                {#each images as pic}
                    <!-- embla-slide -->
                    <div class="embla__slide relative m-0 h-full max-h-full">
                        <slot slide={pic}>
                            <CarouselImage {...pic} />
                        </slot>
                    </div>
                {/each}
            </div>
        </div>
        {#if images.length > 1}
            {#if canScrollPrev}
                <button
                    id="prev"
                    class="absolute top-0 hidden h-full w-1/2 cursor-w-resize p-5 uppercase md:block md:text-2xl"
                    on:click={() => embla.scrollPrev()}
                    disabled={!canScrollPrev}
                    class:disabled={!canScrollPrev}
                >
                    <!-- <div class="icon">Back</div> -->
                </button>
            {/if}
            {#if canScrollNext}
                <button
                    id="next"
                    class="absolute top-0 right-0 hidden h-full w-1/2 cursor-e-resize p-5 uppercase md:block md:text-2xl"
                    on:click={() => embla.scrollNext()}
                    disabled={!canScrollNext}
                    class:disabled={!canScrollNext}
                >
                    <!-- <div class="icon">Next</div> -->
                </button>
            {/if}
        {/if}
    </div>
    {#if images[currentIndex]?.description}
        <div class="md:writing-mode-bt my-5 text-center text-sm md:min-w-[1.25rem]">
            {images[currentIndex]?.description || ''}
        </div>
    {/if}
</section>

<style lang="scss">
    section {
        grid-column: full;
    }

    .embla__slide {
        --slide-width: 100%;
        flex: 0 0 var(--slide-width);
    }
</style>
